export const emailRegex = "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$";
export const urlRegex = "([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?";
export const numbersOnlyRegex = "^[0-9]*$";